import mixpanel from 'mixpanel-browser'
import { MIXPANEL_TOKEN } from './constants'

mixpanel.init(MIXPANEL_TOKEN, { persistence: 'localStorage' })

const getBaseProperties = () => ({
  $current_url:   window.location.href,
  page_name:      'my_account',
  Page:           'my_account',
  $screen_height: window.screen.height,
  $screen_width:  window.screen.width,
  language:       document.documentElement.lang || 'en',
  Channel:          'Intego Website',
  'Initial channel': 'Intego Website',
  media_source:     'direct',
  mp_lib:           'web',
  mo:               'no',
  vpn:              'no',
})

export const trackPageView = (pageName) => {
  mixpanel.track('Page View', {
    ...getBaseProperties(),
    page_name: pageName,
    Page:      pageName,
  })
}

export const trackObjectClicked = (object, extraProperties = {}) => {
  mixpanel.track('website_object_clicked', {
    ...getBaseProperties(),
    event:  'website_object_clicked',
    object,
    ...extraProperties,
  })
}

export default mixpanel